import {
	get as _get
} from 'lodash';

export function getHttpError(httpError: any) {
	return _get(httpError, ['error', 'error', 'message']) || _get(httpError, ['error', 'error', 'error']);
}
